import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { DownOutlined, PaperClipOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import ReactLoading from "react-loading";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toast } from "react-toastify";
import { createFormAttachment } from "../../Helpers/API/CheckUpApi/FormApi";
import { saveForm } from "../../Helpers/API/PatientApi/FormApi";
import { convertQuillToHtml } from "../../../Helpers/Utils/Common";
import { refreshPage } from "../../../Helpers/Utils/Common";
import { FORM } from "../../../Constants/doctor";
import medicine from "../../../Assets/Images/clinica-prime-logo-dark.png";

import "./Buttons.css";
function BtnPdfV2({
  size,
  divId,
  label,
  fileName,
  setFormPdf = (formPdf) => null,
  quill,
  formPdf,
  id,
  typeValue,
  paperType,
}) {
  const [isClicked, setIsClicked] = useState(false);
  const items = [
    {
      label: "A5",
      key: "a5",
      icon: <PaperClipOutlined />,
    },
    {
      label: "A4",
      key: "a4",
      icon: <PaperClipOutlined />,
    },
    {
      label: "Letter",
      key: "letter",
      icon: <PaperClipOutlined />,
    },
    {
      label: "Legal",
      key: "legal",
      icon: <PaperClipOutlined />,
    },
  ];

  // SAVE FORM CONTENTS
  async function handleSaveForm(paperType) {
    setIsClicked(true);
    var quillDelta = quill.getContents();
    var quillHtml = convertQuillToHtml(quillDelta);

    const response = await saveForm({
      patient_id: id,
      form_template_id: typeValue.value,
      content: quillHtml,
    });

    if (response.error) {
      response.error?.data?.messages.forEach((data) => {
        toast.error(data);
      });
    } else {
      toast.success(response.data.message, { autoClose: 1000 });
      handlePrint(response.data.form_id, paperType.key);
    }
    setFormPdf(null);
    setIsClicked(false);
  }

  // UPLOAD FILE TO PATIENT ATTACHMENTS
  async function handleUploadFile(formId, form_Pdf) {
    const response = await createFormAttachment(
      id, // patient id
      [{ file: form_Pdf }], // attachment
      typeValue.label, // form template label
      formId, // form id
      typeValue.value //form template id
    );
    if (response.error) {
      response.error?.data?.messages.map((data) => {
        return toast.error(data);
      });
    } else {
      toast.success(response.data.message, { autoClose: 1000 });
      setTimeout(() => {
        refreshPage();
      }, 3000);
    }
  }

  const handlePrint = async (form_id, paperType) => {
    const input = document.getElementById(divId || "antd-table-container");

    // Add built-in header to tempDiv
    const headerDiv = document.createElement("div");
    headerDiv.className = "header";
    headerDiv.style.border = "none";
    headerDiv.innerHTML = `
      <div class="d-flex row justify-content-center">
        <div class="row text-center">
          <div class="col w-full">
            <label>
              <h1>
                <img src="${medicine}" className="header-logo" alt="logo" />
              </h1>
            </label>
          </div>
        </div>
      </div>
      <hr/>
    `;

    // Create a wrapper for content and add padding to it
    const contentWrapper = document.createElement("div");
    contentWrapper.className = "content-wrapper";
    contentWrapper.style.marginLeft = "70px";
    contentWrapper.style.marginRight = "70px";
    while (input.firstChild) {
      contentWrapper.appendChild(input.firstChild);
    }

    input.appendChild(headerDiv);
    input.appendChild(contentWrapper);

    document.body.appendChild(input);
    input.style.border = "none";
    input.style.fontSize = "1rem";

    // Convert HTML to canvas
    html2canvas(input, { backgroundColor: null }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", paperType, true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 5;

      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );

      // Save pdf file locally
      // pdf.save(fileName);
      pdf.autoPrint();
      pdf.output("dataurlnewwindow");

      // Convert the pdf file from Blob to File obj (needed for upload API)
      const blobPdf = pdf.output("blob");
      const formPdf = new File([blobPdf], `${fileName}`, {
        type: blobPdf.type,
      });

      setFormPdf(() => formPdf);
      handleUploadFile(form_id, formPdf);
    });
  };

  const menuProps = {
    items,
    onClick: (e) => handleSaveForm(e),
  };

  return (
    <Col className="mb-2">
      {isClicked ? (
        <Button className="action-btn clear loader" size={size}>
          <ReactLoading type={"balls"} height={20} width={25} color="#2d6e5e" />
        </Button>
      ) : (
        <Button
          className="action-btn clear"
          size={size}
          onClick={() => handleSaveForm(paperType)}
        >
          {label || "Download PDF"}
        </Button>
        // <Dropdown menu={menuProps}>
        //   <Button className="action-btn clear" size={size}>
        //       {label || "Download PDF"}
        //       <DownOutlined />
        //   </Button>
        // </Dropdown>
      )}
    </Col>
  );
}

export default BtnPdfV2;
